import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import InputMask from 'react-input-mask';
import Toggle from 'react-toggle';
import Select from 'react-select';
import { Modal } from 'react-bootstrap';

import FlightReportOfflineLegEditViewTab from './FlightReportOfflineLegEditViewTab';
import FlightReportOfflineLegEditTab from './FlightReportOfflineLegEditTab';
import moment from 'moment';

class FlightReportOfflineLegsTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      modal_alerts: false,
      loaded: false,
      modal: false,
      flight_report_id: null,
      departure_location_id: null,
      arrival_location_id: null,
      date: null,
      leg_number: null,
      takeoff_scheduled: null,
      total_time_preview: null,
      engine_start_time: null,
      start_parameter_total: null,
      takeoff_time: null,
      landing_time: null,
      engine_shutoff_time: null,
      takeoff_land_time: '00:00',
      total_time: '00:00',
      navigation_time: '00:00',
      ifr_time: '00:00',
      night_time: '00:00',
      day_landings: 0,
      night_landings: 0,
      starts: null,
      pax: 0,
      payload: 0,
      external_load_long_line: 0,
      external_load_short_line: 0,
      fuel_start: 0,
      fuel_end: 0,
      ptbr_code_id: null,
      ptbr_operation_id: null,
      ptbr_external_load_id: null,
      delay_time: '00:00',
      delay_departure: '00:00',
      flight_report_legs: {},
      flight_report_legs_view: {},
      locations_select: [],
      ptbr_codes_select: [],
      ptbr_operations_select: [],
      ptbr_external_loads_select: [],
      staffs_select: [],
      duties_select: [],
      flight_report_leg_edit: {},
      flight_report_leg_edit_staffs: {},
      frl_alerts: {},
    };

    this.add = this.add.bind(this);
    this.addMobile = this.addMobile.bind(this);
    this.diffFlight = this.diffFlight.bind(this);
    this.diffTotalTime = this.diffTotalTime.bind(this);
    this.delayFlight = this.delayFlight.bind(this);
    this.delayTotalTime = this.delayTotalTime.bind(this);
    this.calcTimeFromMs = this.calcTimeFromMs.bind(this);
    this.autoFillTime = this.autoFillTime.bind(this);
    this.openModal = this.openModal.bind(this);
    this.delete = this.delete.bind(this);
    this.saveOnline = this.saveOnline.bind(this);
  }
  autoFillTime (name) {

    var now = moment(new Date());
    now = now.format("HH:mm");
    var change = {};
    change[name] = now;
    if (name === 'takeoff_time') {
      this.diffFlight(now, this.state.landing_time, change);
      this.delayFlight(now, this.state.takeoff_scheduled, change);
      this.diffTotalTime(this.state.engine_start_time, this.state.engine_shutoff_time, now, this.state.landing_time, this.state.start_parameter_total, change);
    } else if (name === 'landing_time') {
      this.diffFlight(this.state.takeoff_time, now, change);
      this.diffTotalTime(this.state.engine_start_time, this.state.engine_shutoff_time, this.state.takeoff_time, now, this.state.start_parameter_total, change);
    } else if (name === 'engine_start_time') {
      this.diffTotalTime(now, this.state.engine_shutoff_time, this.state.takeoff_time, this.state.landing_time, this.state.start_parameter_total, change);
    } else if (name === 'engine_shutoff_time') {
      this.diffTotalTime(this.state.engine_start_time, now, this.state.takeoff_time, this.state.landing_time, this.state.start_parameter_total, change);
    } else if (name === 'takeoff_scheduled') {
      this.delayFlight(this.state.takeoff_time, now, change);
    } else if (name === 'total_time_preview') {
      this.delayTotalTime(now, this.state.takeoff_land_time, change);
    } else {
      this.setState(change);
    }
  }

  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    if (name === 'takeoff_time') {
      this.diffFlight(event.target.value, this.state.landing_time, change);
      this.delayFlight(event.target.value, this.state.takeoff_scheduled, change);
      this.diffTotalTime(this.state.engine_start_time, this.state.engine_shutoff_time, event.target.value, this.state.landing_time, this.state.start_parameter_total, change);
    } else if (name === 'landing_time') {
      this.diffFlight(this.state.takeoff_time, event.target.value, change);
      this.diffTotalTime(this.state.engine_start_time, this.state.engine_shutoff_time, this.state.takeoff_time, event.target.value, this.state.start_parameter_total, change);
    } else if (name === 'engine_start_time') {
      this.diffTotalTime(event.target.value, this.state.engine_shutoff_time, this.state.takeoff_time, this.state.landing_time, this.state.start_parameter_total, change);
    } else if (name === 'engine_shutoff_time') {
      this.diffTotalTime(this.state.engine_start_time, event.target.value, this.state.takeoff_time, this.state.landing_time, this.state.start_parameter_total, change);
    } else if (name === 'takeoff_scheduled') {
      this.delayFlight(this.state.takeoff_time, event.target.value, change);
    } else if (name === 'total_time_preview') {
      this.delayTotalTime(event.target.value, this.state.takeoff_land_time, change);
    } else {
      this.setState(change);
    }
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  }
  // LM
  componentWillReceiveProps(newProps) {
    if(Array.isArray(newProps.flight_report_legs_view) || (this.state.loaded === 1 && newProps.updated === 1)) {
      var index = newProps.flight_report_legs_view.length-1;
      var start_parameter_total = null;
      if (typeof newProps.flight_report_legs_view[index] !== 'undefined') {
        if (newProps.flight_report_legs_view[index].engine_shutoff_time === null || newProps.flight_report_legs_view[index].engine_shutoff_time === '' || typeof newProps.flight_report_legs_view[index].engine_shutoff_time === 'undefined') {
          start_parameter_total = newProps.flight_report_legs_view[index].landing_time;
        }
      }

      this.setState({
        flight_report_id: newProps.flight_report_id,
        flight_report_legs_view: newProps.flight_report_legs_view,
        locations_select: newProps.locations_select,
        ptbr_codes_select: newProps.ptbr_codes_select,
        staffs_select: newProps.staffs_select,
        duties_select: newProps.duties_select,
        date: newProps.flight_report.date_str,
        external_load: newProps.flight_report.external_load,
        xml: newProps.flight_report.xml,
        status: newProps.flight_report.status,
        start_parameter_total: start_parameter_total,
        loaded: 1,
      });
    }

    var new_flight_report_legs = JSON.parse(localStorage.getItem("new_flight_report_legs_full"));
    if(new_flight_report_legs !== 'undefined' && new_flight_report_legs !== null && new_flight_report_legs !== undefined) {
      this.setState({flight_report_legs: new_flight_report_legs});
    }   

  }
  openModal(modal_errors) {
    this.setState({frl_alerts: modal_errors, modal_alerts:true});
  }

  // Fetch salvando a adição mobile
  addMobile(event) {
    event.preventDefault();
    this.add();
  }

  // Fetch salvando a adição
  add() {
    this.props.handleAlert('', '', 'open');

    let takeoff_scheduled = null;
    let engine_start_time = null;
    let takeoff_time = null;
    let landing_time = null;
    let engine_shutoff_time = null;
    
    if (this.state.takeoff_scheduled) takeoff_scheduled = this.state.date + ' ' + this.state.takeoff_scheduled;
    if (this.state.engine_start_time) engine_start_time = this.state.date + ' ' + this.state.engine_start_time;
    if (this.state.takeoff_time) takeoff_time = this.state.date + ' ' + this.state.takeoff_time;
    if (this.state.landing_time) landing_time = this.state.date + ' ' + this.state.landing_time;
    if (this.state.engine_shutoff_time) engine_shutoff_time = this.state.date + ' ' + this.state.engine_shutoff_time;

    if (takeoff_scheduled) takeoff_scheduled = moment(takeoff_scheduled , "DD/MM/YYYY HH:mm:ss");
    if (engine_start_time) engine_start_time = moment(engine_start_time, "DD/MM/YYYY HH:mm:ss");
    if (takeoff_time) takeoff_time = moment(takeoff_time, "DD/MM/YYYY HH:mm:ss");
    if (landing_time) landing_time = moment(landing_time, "DD/MM/YYYY HH:mm:ss");
    if (engine_shutoff_time) engine_shutoff_time = moment(engine_shutoff_time, "DD/MM/YYYY HH:mm:ss");

    if (takeoff_scheduled) {
        let diff_hours = takeoff_scheduled.diff(takeoff_time, 'hours');
        if (takeoff_time < takeoff_scheduled && diff_hours > 12) {
            if (engine_start_time) engine_start_time.add(1, 'd');
            if (takeoff_time) takeoff_time.add(1, 'd');
            if (landing_time) landing_time.add(1, 'd');
            if (engine_shutoff_time) engine_shutoff_time.add(1, 'd');
        }
    }


    if (takeoff_time > landing_time) {
        if (landing_time) landing_time.add(1, 'd');
    }

    if (engine_start_time > engine_shutoff_time) {
        if (engine_shutoff_time) engine_shutoff_time.add(1, 'd');
    }


    if (engine_start_time) engine_start_time = engine_start_time.format("HH:mm");
    if (takeoff_time) takeoff_time = takeoff_time.format("HH:mm");
    if (landing_time) landing_time = landing_time.format("HH:mm");
    if (engine_shutoff_time) engine_shutoff_time = engine_shutoff_time.format("HH:mm");
    if (takeoff_scheduled) takeoff_scheduled = takeoff_scheduled.format("HH:mm");


    var storage = localStorage.getItem("new_flight_report_legs_full");
    if(storage !== 'undefined' && storage !== null && storage !== undefined) {
        var datasave = {
          flight_report_id: this.props.flight_report_id,
          departure_location_id: this.state.departure_location_id,
          arrival_location_id: this.state.arrival_location_id,
          takeoff_scheduled: takeoff_scheduled,
          total_time_preview: this.state.total_time_preview,
          engine_start_time: engine_start_time,
          takeoff_time: takeoff_time,
          landing_time: landing_time,
          engine_shutoff_time: engine_shutoff_time,
          takeoff_land_time: this.state.takeoff_land_time,
          takeoff_scheduled_str: takeoff_scheduled,
          engine_start_time_str: engine_start_time,
          takeoff_time_str: takeoff_time,
          landing_time_str: landing_time,
          engine_shutoff_time_str: engine_shutoff_time,
          total_time: this.state.total_time,
          navigation_time: this.state.navigation_time,
          ifr_time: this.state.ifr_time,
          night_time: this.state.night_time,
          day_landings: this.state.day_landings,
          night_landings: this.state.night_landings,
          starts: this.state.starts,
          pax: this.state.pax,
          payload: this.state.payload,
          external_load_long_line: this.state.external_load_long_line,
          external_load_short_line: this.state.external_load_short_line,
          fuel_start: this.state.fuel_start,
          fuel_end: this.state.fuel_end,
          delay_time: this.state.delay_time,
          delay_departure: this.state.delay_departure,
          ptbr_code_id: this.state.ptbr_code_id,
          ptbr_operation_id: this.state.ptbr_operation_id,
          ptbr_external_load_id: this.state.ptbr_external_load_id,
          errors: [],
          status: 'pending',
          status_str: 'Pendente',
        };
        
        storage = JSON.parse(storage);
        storage.push(datasave);
        localStorage.setItem("new_flight_report_legs_full", JSON.stringify(storage));
    } else {
        var datasave = [
            {
            flight_report_id: this.props.flight_report_id,
            departure_location_id: this.state.departure_location_id,
            arrival_location_id: this.state.arrival_location_id,
            takeoff_scheduled: takeoff_scheduled,
            total_time_preview: this.state.total_time_preview,
            engine_start_time: engine_start_time,
            takeoff_time: takeoff_time,
            landing_time: landing_time,
            engine_shutoff_time: engine_shutoff_time,
            takeoff_land_time: this.state.takeoff_land_time,
            takeoff_scheduled_str: takeoff_scheduled,
            engine_start_time_str: engine_start_time,
            takeoff_time_str: takeoff_time,
            landing_time_str: landing_time,
            engine_shutoff_time_str: engine_shutoff_time,
            total_time: this.state.total_time,
            navigation_time: this.state.navigation_time,
            ifr_time: this.state.ifr_time,
            night_time: this.state.night_time,
            day_landings: this.state.day_landings,
            night_landings: this.state.night_landings,
            starts: this.state.starts,
            pax: this.state.pax,
            payload: this.state.payload,
            external_load_long_line: this.state.external_load_long_line,
            external_load_short_line: this.state.external_load_short_line,
            fuel_start: this.state.fuel_start,
            fuel_end: this.state.fuel_end,
            delay_time: this.state.delay_time,
            delay_departure: this.state.delay_departure,
            ptbr_code_id: this.state.ptbr_code_id,
            ptbr_operation_id: this.state.ptbr_operation_id,
            ptbr_external_load_id: this.state.ptbr_external_load_id,
            status: 'pending',
            status_str: 'Pendente',
          }
        ];
        localStorage.setItem("new_flight_report_legs_full", JSON.stringify(datasave));
    }

        
    var storage = JSON.parse(localStorage.getItem("new_flight_report_legs_full"));

    var departure_location_id = null;
    var fuel_start = 0;
    this.setState({
      flight_report_legs: storage,
      departure_location_id: departure_location_id,
      arrival_location_id: null,
      takeoff_scheduled: '',
      total_time_preview: '',
      engine_start_time: '',
      takeoff_time: '',
      landing_time: '',
      engine_shutoff_time: '',
      takeoff_land_time: '00:00',
      total_time: '00:00',
      navigation_time: '',
      ifr_time: '',
      night_time: '',
      day_landings: 0,
      night_landings: 0,
      starts: 0,
      pax: 0,
      payload: 0,
      external_load_long_line: 0,
      external_load_short_line: 0,
      fuel_start: fuel_start,
      fuel_end: 0,
      delay_time: '',
      delay_departure: '',
      ptbr_code_id: null,
      ptbr_operation_id: null,
      ptbr_external_load_id: null,
    });
  
    this.props.handleAlert('', '', 'closed');


  }


  diffFlight(takeoff_time, landing_time, change) {
    if (takeoff_time && landing_time && takeoff_time !== '' && landing_time !== '') {
      takeoff_time = this.state.date + ' ' + takeoff_time;
      landing_time = this.state.date + ' ' + landing_time;

      takeoff_time = moment(takeoff_time, "DD/MM/YYYY HH:mm:ss");
      landing_time = moment(landing_time, "DD/MM/YYYY HH:mm:ss");
      
      if (takeoff_time > landing_time) {
        landing_time.add(1, 'd');
      }
      
      takeoff_time = new Date(takeoff_time.format("YYYY-MM-DD HH:mm:ss").replace(/ /g,"T"));
      landing_time = new Date(landing_time.format("YYYY-MM-DD HH:mm:ss").replace(/ /g,"T"));
      
      let diffTime = Math.abs(landing_time.getTime() - takeoff_time.getTime());

      if (landing_time > takeoff_time) {
        change['takeoff_land_time'] = this.calcTimeFromMs(diffTime);
        change['navigation_time'] = this.calcTimeFromMs(diffTime);
      } else {
        change['takeoff_land_time'] = '00:00';
        change['navigation_time'] = '00:00';
      }
    } else {
      change['takeoff_land_time'] = '00:00';
      change['navigation_time'] = '00:00';
    }
    this.delayTotalTime(this.state.total_time_preview, change['takeoff_land_time'], change);
  }

  diffTotalTime(engine_start_time, engine_shutoff_time, takeoff_time, landing_time, start_parameter_total, change) {
    let start = null;
    if (engine_start_time !== null && engine_start_time !== '' && typeof engine_start_time !== 'undefined') {
      start = engine_start_time;
    } else if (start_parameter_total !== null) {
      start = start_parameter_total.substring(11);
    }

    let finish = null;
    if (landing_time !== null && landing_time !== '' && typeof landing_time !== 'undefined') {
      finish = landing_time;
    }
    if (engine_shutoff_time !== null && engine_shutoff_time !== '' && typeof engine_shutoff_time !== 'undefined') {
      finish = engine_shutoff_time;
    }

    if(start && finish) {
      start = this.state.date + ' ' + start;
      finish = this.state.date + ' ' + finish;

      start = moment(start, "DD/MM/YYYY HH:mm:ss");
      finish = moment(finish, "DD/MM/YYYY HH:mm:ss");

      if (start > finish) {
        finish.add(1, 'd');
      }

      start = new Date(start.format("YYYY-MM-DD HH:mm:ss").replace(/ /g,"T"));
      finish = new Date(finish.format("YYYY-MM-DD HH:mm:ss").replace(/ /g,"T"));

      let diffTime = Math.abs(finish.getTime() - start.getTime());
      if (finish > start) {
        change['total_time'] = this.calcTimeFromMs(diffTime);
      } else {
        change['total_time'] = '00:00';
      }

      this.setState(change);
    } else {
      change['total_time'] = '00:00';
      this.setState(change);
    }
  }

  delayFlight(takeoff_time, takeoff_scheduled, change) {
    if(takeoff_scheduled) {
      takeoff_time = this.state.date + ' ' + takeoff_time;
      takeoff_scheduled = this.state.date + ' ' + takeoff_scheduled;

      takeoff_time = moment(takeoff_time, "DD/MM/YYYY HH:mm:ss");
      takeoff_scheduled = moment(takeoff_scheduled, "DD/MM/YYYY HH:mm:ss");

      let diff_hours = takeoff_scheduled.diff(takeoff_time, 'hours');

      if (takeoff_time < takeoff_scheduled && diff_hours > 12) {
        takeoff_time.add(1, 'd');
      }

      takeoff_time = new Date(takeoff_time.format("YYYY-MM-DD HH:mm:ss").replace(/ /g,"T"));
      takeoff_scheduled = new Date(takeoff_scheduled.format("YYYY-MM-DD HH:mm:ss").replace(/ /g,"T"));
      let diffTime = Math.abs(takeoff_time.getTime() - takeoff_scheduled.getTime());
      if (takeoff_time > takeoff_scheduled) {
        change['delay_departure'] = this.calcTimeFromMs(diffTime);
      } else {
        change['delay_departure'] = '00:00';
      }
    } else {
      change['delay_departure'] = '00:00';
    }
    this.setState(change);
  }

  delayTotalTime(total_time_preview, takeoff_land_time, change) {
    if(takeoff_land_time && total_time_preview) {
      takeoff_land_time = moment().format("YYYY-MM-DD") + ' ' + takeoff_land_time;
      total_time_preview = moment().format("YYYY-MM-DD") + ' ' + total_time_preview;

      takeoff_land_time = new Date(takeoff_land_time.replace(/ /g,"T"));
      total_time_preview = new Date(total_time_preview.replace(/ /g,"T"));
      let diffTime = Math.abs(takeoff_land_time.getTime() - total_time_preview.getTime());
      if (takeoff_land_time > total_time_preview) {
        change['delay_time'] = this.calcTimeFromMs(diffTime);
      } else {
        change['delay_time'] = '00:00';
      }
    } else {
      change['delay_time'] = '00:00';
    }
    this.setState(change);
  }

  calcTimeFromMs(diffTime) {
    diffTime = diffTime/1000;
    var secs = diffTime % 60;
    diffTime = (diffTime - secs) / 60;
    var mins = diffTime % 60;
    var hrs = (diffTime - mins) / 60;
    if (secs < 10) { secs = '0' + secs; }
    if (mins < 10) { mins = '0' + mins; }
    if (hrs < 10) { hrs = '0' + hrs; }
    return hrs + ':' + mins + ':' + secs ;
  }

  delete(index_key) {

    var storage = localStorage.getItem("new_flight_report_legs_full");

    storage = JSON.parse(storage);
    storage.splice(index_key, 1);

    localStorage.setItem("new_flight_report_legs_full", JSON.stringify(storage));

    var storage = JSON.parse(localStorage.getItem("new_flight_report_legs_full"));

    this.setState({flight_report_legs: storage});

  }

  saveOnline() {
    var self = this;
    if(navigator.onLine) {
      this.props.handleAlert('', '', 'open');
      var header = self.refs.request_api.header('application/json');
      var new_flight_report_legs_full = JSON.parse(localStorage.getItem("new_flight_report_legs_full"));

      var datasave = {
        new_flight_report_legs_full: new_flight_report_legs_full,
      };
      if((new_flight_report_legs_full !== 'undefined' && new_flight_report_legs_full !== null && new_flight_report_legs_full !== undefined && new_flight_report_legs_full.length > 0)) {
        Promise.resolve(header).then(function(value) {
          var url = config.get('api') + '/portal/relatorios/salvar/offline';
          fetch(url, { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
            self.refs.request_api.validate(responseJson, 'url');
            if (responseJson.status === 'success') {
              if(responseJson.data === true) {
                localStorage.removeItem("new_flight_report_legs");
                localStorage.removeItem("new_flight_report_legs_full");
                self.props.handleAlert('Os relatórios de voo offline foram salvos.', 'success', 'open');
              } else {
                localStorage.setItem("new_flight_report_legs_full", JSON.stringify(responseJson.data));
                self.props.handleAlert('Alguns trechos encontram-se com erro.', 'warning', 'open');
              }
            }
          });
        });
      } else {
        this.props.handleAlert('', '', 'closed');
      }
    }
  }



  render() {
    var self = this;
    let start_parameter_total = null;
    let total = 1;
    let style = {
      form: {width: '100%', height: 'auto', overflowX: 'auto', whiteSpace: 'nowrap'},
      input_hour: {width: '75px', textAlign: 'center'},
      select_places: {width: '130px'},
      select_operation: {width: '240px'},
      input_number: {width: '70px', textAlign: 'center'},
      divs: {display: 'inline-block', marginRight: '15px'},
    };
    return (
<div>
  <RequestApi ref={'request_api'} />
  <h3 className="page-title">Cadastrar trecho</h3>
  <form onSubmit={this.addMobile} className="visible-xs">
    <hr />
    <div className="row">
      <div className="col-md-3 form-group">
        <label>Origem</label>
        <Select
          className="form-field-name"
          name="departure_location_id"
          value={this.state.departure_location_id}
          searchable={true}
          placeholder={''}
          onChange={this.handleSelectChange.bind(this, 'departure_location_id')}
          options={this.state.locations_select}
        />
      </div>
      <div className="col-md-3 form-group">
        <label>Destino</label>
        <Select
          className="form-field-name"
          name="arrival_location_id"
          value={this.state.arrival_location_id}
          searchable={true}
          placeholder={''}
          onChange={this.handleSelectChange.bind(this, 'arrival_location_id')}
          options={this.state.locations_select}
        />
      </div>
      <div className="col-md-3 form-group">
        <label>Partida</label>
        <InputMask value={this.state.engine_start_time}  maskChar={null} name="engine_start_time" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'engine_start_time')} placeholder=""  />
      </div>
      <div className="col-md-3 form-group">
        <label>DEC.</label>
        <InputMask value={this.state.takeoff_time}  maskChar={null} name="takeoff_time" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'takeoff_time')} placeholder=""  />
      </div>
      <div className="col-md-3 form-group">
        <label>POU.</label>
        <InputMask value={this.state.landing_time}  maskChar={null} name="landing_time" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'landing_time')} placeholder=""  />
      </div>
      <div className="col-md-3 form-group">
        <label>Corte</label>
        <InputMask value={this.state.engine_shutoff_time}  maskChar={null} name="engine_shutoff_time" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'engine_shutoff_time')} placeholder="" />
      </div>
      <div className="col-md-3 form-group">
        <label>DEC-POU</label>
        <InputMask value={this.state.takeoff_land_time}  maskChar={null} name="takeoff_land_time" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'takeoff_land_time')} placeholder="" disabled />
      </div>
      <div className="col-md-3 form-group">
        <label>Total</label>
        <InputMask value={this.state.total_time}  maskChar={null} name="total_time" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'total_time')} placeholder="" disabled />
      </div>
      <div className="col-md-3 form-group">
        <label>Nav.</label>
        <InputMask value={this.state.navigation_time}  maskChar={null} name="navigation_time" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'navigation_time')} placeholder=""  />
      </div>
      <div className="col-md-3 form-group">
        <label>IFR</label>
        <InputMask value={this.state.ifr_time}  maskChar={null} name="ifr_time" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'ifr_time')} placeholder=""  />
      </div>
      <div className="col-md-3 form-group">
        <label>Noturno</label>
        <InputMask value={this.state.night_time}  maskChar={null} name="night_time" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'night_time')} placeholder=""  />
      </div>
      <div className="col-md-3 form-group">
        <label>Diurnos</label>
        <input type="number" value={this.state.day_landings} name="day_landings " className="form-control" onChange={this.handleChange.bind(this, 'day_landings')} placeholder=""  />
      </div>
      <div className="col-md-3 form-group">
        <label>Noturnos</label>
        <input type="number" value={this.state.night_landings} name="night_landings " className="form-control" onChange={this.handleChange.bind(this, 'night_landings')} placeholder=""  />
      </div>
      <div className="col-md-3 form-group">
        <label>Partidas</label>
        <input type="number" value={this.state.starts} name="starts " className="form-control" onChange={this.handleChange.bind(this, 'starts')} placeholder="" />
      </div>
      <div className="col-md-3 form-group">
        <label>PAX</label>
        <input type="number" value={this.state.pax} name="pax " className="form-control" onChange={this.handleChange.bind(this, 'pax')} placeholder=""  />
      </div>
      <div className="col-md-3 form-group">
        <label>Carga</label>
        <input type="number" value={this.state.payload} name="payload " className="form-control" onChange={this.handleChange.bind(this, 'payload')} placeholder=""  />
      </div>

      {this.state.external_load == 1 ? 
        <div className="col-md-3 col-xs-6 form-group">
          <label>Long Line</label>
          <br/>
          <Toggle
            checked={this.state.external_load_long_line}
            aria-label='No label tag'
            name="external_load_long_line"
            onChange={this.handleToggleChange.bind(this, 'external_load_long_line')} />
        </div>
        : ''
      }
      {this.state.external_load == 1 ? 
        <div className="col-md-3 col-xs-6 form-group">
          <label>Short Line</label>
          <br/>
          <Toggle
            checked={this.state.external_load_short_line}
            aria-label='No label tag'
            name="external_load_short_line"
            onChange={this.handleToggleChange.bind(this, 'external_load_short_line')} />
        </div>
      : ''
      }

      <div className="col-md-3 form-group">
        <label>Inicial</label>
        <input type="number" value={this.state.fuel_start} name="fuel_start " className="form-control" onChange={this.handleChange.bind(this, 'fuel_start')} placeholder=""  />
      </div>
      <div className="col-md-3 form-group">
        <label>Final</label>
        <input type="number" value={this.state.fuel_end} name="fuel_end " className="form-control" onChange={this.handleChange.bind(this, 'fuel_end')} placeholder=""  />
      </div>
      {this.state.xml == 1 ? 
        <div className="col-md-3 form-group">
          <label>Código PTBR &nbsp;&nbsp;<button type="button" onClick={() => this.exportPtbrCode()} className="btn btn-success btn-xs"><i className="fa fa-fw fa-file-pdf-o"></i></button></label>
          <Select
            className="form-field-name"
            name="ptbr_code_id"
            value={this.state.ptbr_code_id}
            searchable={true}
            placeholder={''}
            onChange={this.handleSelectChange.bind(this, 'ptbr_code_id')}
            options={this.state.ptbr_codes_select}
          />
        </div>
      : ''
      }
    </div>
    <button type="submit" className="btn btn-primary btn-block"><i className="fa fa-fw fa-save"></i> Adicionar Trecho</button>
  </form>
  <hr/>
  <button type="button" className="btn btn-sm btn-success pull-left" onClick={() => {self.saveOnline()}}><i className="fa fa-fw fa-refresh"></i>Enviar para o servidor</button>
  <div className="clearfix"></div>
  <hr/>
  <div className="table-responsive">
    <table className="table table-bordered table-hover table-striped">
      <thead>
        <tr>
          <th></th>
          <th colSpan={4}></th>
          <th colSpan={13} className="text-center">Realizado</th>
          <th colSpan={2} className="text-center">Pousos</th>
          <th colSpan={3} className="text-center">Dados</th>
          {this.state.external_load == 1 ? 
            <th colSpan={2} className="text-center">Carga externa</th>
          : ''
          }
          <th colSpan={2} className="text-center">Combustível</th>
          {this.state.xml == 1 ? 
            <th colSpan={1} className="text-center">Operação PTBR <button type="button" onClick={() => this.exportPtbrCode()} className="btn btn-success btn-xs"><i className="fa fa-fw fa-file-pdf-o"></i></button></th>
          : ''
          }
          <th className="text-center">Ações</th>
          <th>Status</th>
        </tr>
        <tr>
          <th className="text-center"></th>
          <th className="text-center" style={{width: '200px'}}>N°</th>
          <th className="text-center">Trecho</th>
          <th className="text-center">Origem</th>
          <th className="text-center">Destino</th>
          <th colSpan={2} className="text-center">Partida</th>
          <th colSpan={2} className="text-center">DEC.</th>
          <th colSpan={2} className="text-center">POU.</th>
          <th colSpan={2} className="text-center">Corte</th>
          <th className="text-center">DEC-POU</th>
          <th className="text-center">Total</th>
          <th className="text-center">Nav.</th>
          <th className="text-center">IFR</th>
          <th className="text-center">Noturno</th>
          <th className="text-center">Diurnos</th>
          <th className="text-center">Noturnos</th>
          <th className="text-center">Partidas</th>
          <th className="text-center">PAX</th>
          <th className="text-center">Carga</th>

          {this.state.external_load == 1 ? 
            <th className="text-center">Long Line</th>
          : ''
          }
          {this.state.external_load == 1 ? 
            <th className="text-center">Short Line</th>
          : ''
          }
          <th className="text-center">Inicial</th>
          <th className="text-center">Final</th>
          {this.state.xml == 1 ? 
            <th className="text-center">Código PTBR </th>
          : ''
          }
          <th className="text-center" style={{width: '200px'}}></th>
        </tr>
      </thead>
      <tbody>
        {Object.keys(self.state.flight_report_legs_view).map(function(k) {
          var srl = self.state.flight_report_legs_view[k];
          var last_index = (parseInt(k) - 1);
          if (typeof self.state.flight_report_legs_view[last_index] !== 'undefined') {
            if (self.state.flight_report_legs_view[last_index].engine_shutoff_time === null || self.state.flight_report_legs_view[last_index].engine_shutoff_time === '' || typeof self.state.flight_report_legs_view[last_index].engine_shutoff_time === 'undefined') {
              start_parameter_total = self.state.flight_report_legs_view[last_index].landing_time;
            }
          }
          var index = self.state.flight_report_legs_view.length;
          index--;
          let edit = false;
          if (parseInt(k) === index) {
            edit = true;
          }
          return (
            <FlightReportOfflineLegEditViewTab external_load={self.state.external_load} xml={self.state.xml} flight_report_leg_edit={srl} locations_select={self.state.locations_select} ptbr_codes_select={self.state.ptbr_codes_select} date={self.state.date} style={style} start_parameter_total={start_parameter_total} />
          );
        })}
        {Object.keys(self.state.flight_report_legs).map(function(k) {
          var srl = self.state.flight_report_legs[k];
          var last_index = (parseInt(k) - 1);
          if (typeof self.state.flight_report_legs[last_index] !== 'undefined') {
            if (self.state.flight_report_legs[last_index].engine_shutoff_time === null || self.state.flight_report_legs[last_index].engine_shutoff_time === '' || typeof self.state.flight_report_legs[last_index].engine_shutoff_time === 'undefined') {
              start_parameter_total = self.state.flight_report_legs[last_index].landing_time;
            }
          }
          var index = self.state.flight_report_legs.length;
          index--;
          let edit = false;
          if (parseInt(k) === index) {
            edit = true;
          }
          if(srl.flight_report_id == self.state.flight_report_id) {
            return (
            <FlightReportOfflineLegEditTab index_key={k} openModal={self.openModal} delete={self.delete} handleAlert={self.props.handleAlert} external_load={self.state.external_load} xml={self.state.xml} flight_report_leg_edit={srl} locations_select={self.state.locations_select} ptbr_codes_select={self.state.ptbr_codes_select} date={self.state.date} style={style} start_parameter_total={start_parameter_total} />
            );

          }
        })}
        {self.state.status == 1
        ?
          <tr>
            <td></td>
            <td></td>
            <td></td>
            <td>
              <Select
                className="form-field-name"
                style={style.select_places}
                name="departure_location_id"
                value={this.state.departure_location_id}
                searchable={true}
                placeholder={''}
                onChange={this.handleSelectChange.bind(this, 'departure_location_id')}
                options={this.state.locations_select}

              />
            </td>
            <td>
              <Select
                className="form-field-name"
                style={style.select_places}
                name="arrival_location_id"
                value={this.state.arrival_location_id}
                searchable={true}
                placeholder={''}
                onChange={this.handleSelectChange.bind(this, 'arrival_location_id')}
                options={this.state.locations_select}

              />
            </td>
            <td>
              <InputMask style={style.input_hour} value={this.state.engine_start_time}  maskChar={null} name="engine_start_time" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'engine_start_time')} placeholder=""  />
            </td>
            <td>
                <button type="button" className="btn btn-primary btn-sm" onClick={() => {self.autoFillTime('engine_start_time')}}><i className="fa fa-fw fa-clock-o"></i></button>
            </td>
            <td>
              <InputMask style={style.input_hour} value={this.state.takeoff_time}  maskChar={null} name="takeoff_time" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'takeoff_time')} placeholder=""  />
            </td>
            <td>
                <button type="button" className="btn btn-primary btn-sm" onClick={() => {self.autoFillTime('takeoff_time')}}><i className="fa fa-fw fa-clock-o"></i></button>
            </td>
            <td>
              <InputMask style={style.input_hour} value={this.state.landing_time}  maskChar={null} name="landing_time" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'landing_time')} placeholder=""  />
            </td>
            <td>
                <button type="button" className="btn btn-primary btn-sm" onClick={() => {self.autoFillTime('landing_time')}}><i className="fa fa-fw fa-clock-o"></i></button>
            </td>
            <td>
              <InputMask style={style.input_hour} value={this.state.engine_shutoff_time}  maskChar={null} name="engine_shutoff_time" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'engine_shutoff_time')} placeholder="" />
            </td>
            <td>
                <button type="button" className="btn btn-primary btn-sm" onClick={() => {self.autoFillTime('engine_shutoff_time')}}><i className="fa fa-fw fa-clock-o"></i></button>
            </td>
            <td>
              <InputMask style={style.input_hour} value={this.state.takeoff_land_time}  maskChar={null} name="takeoff_land_time" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'takeoff_land_time')} placeholder="" disabled />
            </td>
            <td>
              <InputMask style={style.input_hour} value={this.state.total_time}  maskChar={null} name="total_time" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'total_time')} placeholder="" disabled />
            </td>
            <td>
              <InputMask style={style.input_hour} value={this.state.navigation_time}  maskChar={null} name="navigation_time" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'navigation_time')} placeholder=""  />
            </td>
            <td>
              <InputMask style={style.input_hour} value={this.state.ifr_time}  maskChar={null} name="ifr_time" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'ifr_time')} placeholder=""  />
            </td>
            <td>
              <InputMask style={style.input_hour} value={this.state.night_time}  maskChar={null} name="night_time" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'night_time')} placeholder=""  />
            </td>
            <td>
              <input style={style.input_number} type="number" value={this.state.day_landings} name="day_landings " className="form-control" onChange={this.handleChange.bind(this, 'day_landings')} placeholder=""  />
            </td>
            <td>
              <input style={style.input_number} type="number" value={this.state.night_landings} name="night_landings " className="form-control" onChange={this.handleChange.bind(this, 'night_landings')} placeholder=""  />
            </td>
            <td>
              <input style={style.input_number} type="number" value={this.state.starts} name="starts " className="form-control" onChange={this.handleChange.bind(this, 'starts')} placeholder="" />
            </td>
            <td>
              <input style={style.input_number} type="number" value={this.state.pax} name="pax " className="form-control" onChange={this.handleChange.bind(this, 'pax')} placeholder=""  />
            </td>
            <td>
              <input style={style.input_number} type="number" value={this.state.payload} name="payload " className="form-control" onChange={this.handleChange.bind(this, 'payload')} placeholder=""  />
            </td>
            {this.state.external_load == 1 ? 
              <td>
                <br/>
                <Toggle
                  checked={this.state.external_load_long_line}
                  aria-label='No label tag'
                  name="external_load_long_line"
                  onChange={this.handleToggleChange.bind(this, 'external_load_long_line')} />
              </td>

            : ''
            }
            {this.state.external_load == 1 ? 
              <td>
                <br/>
                <Toggle
                  checked={this.state.external_load_short_line}
                  aria-label='No label tag'
                  name="external_load_short_line"
                  onChange={this.handleToggleChange.bind(this, 'external_load_short_line')} />
              </td>
            : ''
            }
            <td>
              <input style={style.input_number} type="number" value={this.state.fuel_start} name="fuel_start " className="form-control" onChange={this.handleChange.bind(this, 'fuel_start')} placeholder=""  />
            </td>
            <td>
              <input style={style.input_number} type="number" value={this.state.fuel_end} name="fuel_end " className="form-control" onChange={this.handleChange.bind(this, 'fuel_end')} placeholder=""  />
            </td>
            {this.state.xml == 1 ? 
              <td>
                <Select
                  className="form-field-name"
                  name="ptbr_code_id"
                  value={this.state.ptbr_code_id}
                  searchable={true}
                  placeholder={''}
                  onChange={this.handleSelectChange.bind(this, 'ptbr_code_id')}
                  options={this.state.ptbr_codes_select}
                  style={style.select_operation}
                />
              </td>
            : ''
            }
            <td>Criação</td>
            <td style={{width: '200px', whiteSpace: 'nowrap', textAlign: 'center'}}>
              <button type="button" className="btn btn-primary" onClick={() => {self.add()}}><i className="fa fa-fw fa-save"></i></button>
            </td>
          </tr>
        :
        ''
        }
      </tbody>
    </table>
  </div>
  <hr/>
  <Modal show={this.state.modal_alerts} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
    <Modal.Header>
      <h4 className="pull-left"><strong>Alertas</strong></h4>
      <button className="btn btn-danger btn-sm pull-right" onClick={() => this.setState({modal_alerts: false})}><i className="fa fa-fw fa-close"></i></button>
      <div className="clearfix"></div>
    </Modal.Header>
    <Modal.Body>
      {
        <div>
          {Object.keys(self.state.frl_alerts).map(function(k) {
            return(
              <div className={"box-alert box-alert-" + self.state.frl_alerts[k].color}>
                <div dangerouslySetInnerHTML={{__html: self.state.frl_alerts[k].message}}></div>
              </div>
            );
          })}
        </div>
      }
    </Modal.Body>
    <Modal.Footer>
      <button className="btn btn-danger btn-sm pull-right" onClick={() => this.setState({modal_alerts: false})}>
      <i className="fa fa-fw fa-close"></i></button>
    </Modal.Footer>
  </Modal>
</div>
    );
  }
}

export default FlightReportOfflineLegsTab;



// WEBPACK FOOTER //
// ./src/Components/FlightReports/Elements/FlightReportOfflineLegsTab.js